export function fetch(name) {
  return `FETCH_${name}`;
}

export function clear(name) {
  return `CLEAR_${name}`;
}

export function open(name) {
  return `OPEN_${name}`;
}

export function close(name) {
  return `CLOSE_${name}`;
}
